import { Position } from './positions';

export const routes = {
    '/': '/',
    '/uikit': '/uikit',
    '/campaign': '/campaign',
    '/app-development': '/app-development',
    '/about-us': '/about-us',
    '/contact': '/contact',
    '/contact/prague': '/contact/prague',
    '/contact/berlin': '/contact/berlin',
    '/contact/thank-you-inquiry': '/contact/thank-you-inquiry',
    '/contact/thank-you-hr': '/contact/thank-you-hr',
    '/app-workshop': '/app-workshop',
    '/career': '/career',
    '/designPage': '/designPage',
    '/inquiry': '/inquiry',
    '/references': '/references',
    '/references/archive': '/references/archive',
    '/christmas2020': '/christmas2020',
    '/404': '/404.html',
    '/cookiesPage': '/cookiesPage',
    '/blog': '/blog',

    references: {
        cosmo: '/cosmo',
        zonky: '/zonky',
        bundestag: '/bundestag',
        samsung: '/samsung',
        kosik: '/kosik',
        kolofix: '/kolofix',
        hi5: '/hi5',
        ventusky: '/ventusky',
        babysitting: '/babysitting',
        ethereum: '/ethereum',
        skodamoped: '/skodamoped',
        pzr: '/pzr',
        obbod: '/obbod',
        tmobile: '/tmobile',
        bazos: '/bazos',
        equa: '/equa',
        oto: '/oto',
        rekola: '/rekola',
        nevdama: '/nevdama',
        virgla: '/virgla',
        grenke: '/grenke',
        tamtam: '/tamtam',
        tapito: '/tapito',
        fakturoid: '/fakturoid',
        carolina: '/carolina',
        angelcam: '/angelcam',
        praguer: '/praguer',
        pocketFennec: '/pocket-fennec',
        cooljam: '/cooljam-tour',
        easyRedmine: '/easy-redmine',
        kitaportfolio: '/kitaportfolio',
        deliveryhero: '/deliveryhero',
        flashsport: '/references/flashsport',
        flashnews: '/references/flashnews',
        citymove: '/references/citymove',
        wwf: '/reference/wwf',
        cme: '/reference/cme',
        weshare: '/references/weshare',
        moneyStep: '/references/money-step',
        hopi: '/references/hopi',
        simplifa: '/simplifa',
        criticalStates: '/references/critical-states',
        dpnk: '/references/do-prace-na-kole',
        ivysilani: '/references/ivysilani',
        boxNow: '/references/boxnow',
        wwfGhostdiver: '/references/wwf-ghostdiver',
        kviff: '/references/kviff',
        vivents: '/references/vivents',
        mladyZdravotnik: '/references/mlady-zdravotnik',
        glitter: '/references/glitter',
        co2in: '/references/co2in',
        shipmonk: '/references/shipmonk',
        edoklady: '/references/edoklady',
        showcase: '/references/showcase',
        travelFree: '/references/travel-free',
        prochmel: '/references/prochmel',
        jtbanka: '/references/jtbanka',
        omg: '/references/omg-konsent',
        oneplay: '/references/oneplay',
    },

    positions: {
        [Position.ANDROID]: '/career/android-developer',
        [Position.BACKEND]: '/career/backend-developer',
        [Position.FRONTEND]: '/career/frontend-developer',
        [Position.IOS]: '/career/ios-developer',
        [Position.PROJECT_MANAGER]: '/career/project-manager',
        [Position.ACCOUNT_MANAGER]: '/career/account-manager',
        [Position.APP_TESTER]: '/career/app-tester',
        [Position.DESIGNER]: '/career/designer',
        [Position.NOT_FOUND]: '/career/contact',
        [Position.INTERN]: '/career/trainee',
    },
    prArticle: '/about-us/:prArticle',
    blog: {
        page: '/blog/page/:page',
        post: '/blog/:post',
        postsAuthor: '/blog/author/:author/:page?',
        postsCategory: '/blog/category/:category/:page?',
        postsTag: '/blog/tag/:tag/:page?',
        glossaryItem: '/blog/glossary/:glossaryItem',
    },

    notFound: 'notFound',
} as const;
